import type { BatchEditFormProps } from "./batch-edit-form.type";

import { Form } from "antd";

import SidePanelFormFooter from "@/modules/side-panel-form-footer";

import BatchEditFormError from "./batch-edit-form-error";

const BatchEditForm = <FieldValue = unknown,>({
  modelKey,
  form,
  fieldName,
  initialValue,
  onFormChange,
  onFormSubmit,
  hasChanges,
  isPending,
  hasError,
  disabled,
  customErrorMessages,
  children,
}: BatchEditFormProps<FieldValue>) => {
  const formId = `${modelKey}s-batch-edit-${fieldName}`;

  return (
    <Form
      form={form}
      id={formId}
      initialValues={{ [fieldName]: initialValue }}
      onValuesChange={onFormChange}
      onFinish={onFormSubmit}
      layout="vertical"
    >
      {children}
      {hasError && (
        <BatchEditFormError
          modelKey={modelKey}
          customMessages={customErrorMessages}
        />
      )}
      <SidePanelFormFooter
        submitProps={{
          disabled: disabled ? true : !hasChanges,
          loading: isPending,
          form: formId,
        }}
      />
    </Form>
  );
};

export default BatchEditForm;
